import React from 'react';

const TONE_COLORS = {
  green: '#46A631',
  blue: '#1E5AD2',
  purple: '#8b5cf6',
  orange: '#DA6223',
};

/**
 * CircularProgress — compact ring for project progress (Figma Chart ~24px).
 */
const CircularProgress = ({
  value = 0,
  max = 100,
  size = 24,
  strokeWidth = 3,
  tone = 'green',
  className = '',
}) => {
  const percent = Math.min(100, Math.max(0, (value / max) * 100 || 0));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  const stroke = TONE_COLORS[tone] || TONE_COLORS.green;

  return (
    <svg
      className={`circular-progress circular-progress--${tone} ${className}`.trim()}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      aria-hidden="true"
    >
      <circle
        className="circular-progress__track"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={stroke}
        strokeOpacity={0.18}
        strokeWidth={strokeWidth}
      />
      <circle
        className="circular-progress__fill"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export default CircularProgress;
